<template>
  <div>
    <b-input-group>
      <b-input-group-prepend>
        <b-btn
          @click="showModal('changeChatId')"
          variant="secondary">
          {{ nickname ? nickname : user.displayName }}
        </b-btn>
      </b-input-group-prepend>
      <b-form-input
        @keydown.enter.native="sendMessage(message)"
        placeholder="메시지를 입력하세요"
        ref="msgInput"
        v-model.trim="message">
      </b-form-input>
      <b-input-group-append>
        <b-btn @click="sendMessage(message)" variant="primary">보내기</b-btn>
      </b-input-group-append>
    </b-input-group>

    <b-modal
      @cancel="handleCancel"
      id="changeChatId"
      ref="changeChatId"
      title="대화 정보 수정"
      centered>
      <b-form-group label="표시 이름">
        <b-input-group>
          <b-form-input
            :placeholder="nickname ? nickname : user.displayName"
            v-model="nickname"
            type="text">
          </b-form-input>
        </b-input-group>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import {
  mapGetters
  // mapState
} from 'vuex'
// import l from '@/vendor/logger'

export default {
  name: 'ChatInput',

  mounted () {
  },

  data () {
    return {
      message: null,
      nickname: ''
    }
  },

  computed: {
    ...mapGetters('user', [
      'user'
    ])
  },

  methods: {
    sendMessage (msg) {
      this.$store.dispatch('chat/sendMessage', {
        uid: this.user.uid,
        nickname: this.nickname ? this.nickname : this.user.displayName,
        message: this.message
      }).then(() => {
        this.message = null
      })
    },
    showModal (ref) {
      this.$refs[ref].show()
    },
    hideModal (ref) {
      this.$refs[ref].hide()
    },
    handleCancel (evt) {
      this.nickname = this.user.displayName
    }
  }
}
</script>

<style scoped>
</style>
